// A musk ox, modelled facing +X: a low shaggy dark-brown body draped almost to
// the ground, a broad head and down-curving horns. Ported 1:1 from age-of-mcp's
// classic musk-ox.ts, restoring its leg loop + body/coat/head/horn composition.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const [x, z] of [[0.06, 0.04], [0.06, -0.04], [-0.06, 0.04], [-0.06, -0.04]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.011, 0.01, 0.085, 4),
      color: "#2e2018", position: [x!, 0.0425, z!] });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.075, 0), color: "#3e2c1e",
      position: [0, 0.085, 0], scale: [1.8, 1.2, 1.1] },             // shaggy body
    { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#2e2016",
      position: [0, 0.05, 0], scale: [1.9, 1.4, 1.2] },              // hanging coat
    { geometry: new THREE.IcosahedronGeometry(0.04, 0), color: "#4a3424",
      position: [0.11, 0.08, 0], scale: [1.1, 1, 1] },               // head
    { geometry: new THREE.ConeGeometry(0.018, 0.05, 4), color: "#d4cabc",
      position: [0.1, 0.095, 0.038], rotation: [0, 0, -2.5] },       // horn
    { geometry: new THREE.ConeGeometry(0.018, 0.05, 4), color: "#d4cabc",
      position: [0.1, 0.095, -0.038], rotation: [0, 0, -2.5] },
  );
  return parts;
}

export const muskOx = defineModel({
  id: "musk-ox",
  scale: 3.2, // real-world size correction (see Model.scale)
  batchId: "standard",
  name: "Musk ox",
  tags: ["creature","musk","ox","low-poly","age-of-mcp","classic"],
  summary: "Low-poly musk ox.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.16,
  parts: () => partsFor(),
  animations: [],
});
